<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>

    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <h2 class="subtitle">DÉBITO {{i+1}}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">DATA DE INCLUSÃO:</span>
                        <span class="text-uppercase">{{ r?.dataInclusao || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">VENCIMENTO:</span>
                        <span class="text-uppercase">{{ r?.vencimento || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ORIGEM:</span>
                        <span class="text-uppercase">{{ r?.origem || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CONTRATO:</span>
                        <span class="text-uppercase">{{ r?.contrato || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ENTIDADE:</span>
                        <span class="text-uppercase">{{ r?.entidade || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">VALOR:</span>
                        <span class="text-uppercase">{{ r?.valor || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ASSOCIADO:</span>
                        <span class="text-uppercase">{{ r?.associado || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
    </ng-container>
    
</app-card-consulta>